import React, { Component } from "react";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { NonLoginServicesDialog } from ".././home/customModal";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Image from "../Image";

export default class Appbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      responsiveloginDrawer: false,
      clientservices: false,
    };
  }
  openloginResponsiveDrawer = () => {
    this.setState({
      responsiveloginDrawer: !this.state.responsiveloginDrawer,
    });
  };
  openModal = () => {
    this.setState({
      open: true,
      responsiveloginDrawer: false,
    });
  };

  closeModal = () => {
    this.setState({
      open: false,
    });
  };
  handleClickclientservices = () => {
    this.setState({
      clientservices: !this.state.clientservices,
    });
  };
  // handleClickdistributor=()=>{
  //   this.history.push("www.google.com")
  // }
  closeloginResponsiveDrawer = () => {
    this.setState({
      responsiveloginDrawer: !this.state.responsiveloginDrawer,
    });
  };

  render() {
    return (
      <div className="appbardiv">
        <AppBar
          position="static"
          color="inherit"
          className="appbar-div"
          style={{ boxShadow: "0px 0px 0px 0px lightgray", background: "none" }}
        >
          <Toolbar
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "none",
            }}
          >
            <Image
              src={"/images/menu.svg"}
              onClick={this.openloginResponsiveDrawer}
              alt="ham_icon"
              className="menu-logo"
            />
            <div className="login-sidebar">
              <div
                style={{
                  background: "rgba(0, 0, 0, 0.1)",
                  width: 992,
                  top: 65,
                  display: !!this.state.responsiveloginDrawer
                    ? "block"
                    : "none",
                  height: 100,
                  zIndex: 99999,
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    overflow: "scroll",
                    display: "block",
                    background: "white",
                    height: "100vh",
                    width: "60%",
                    color: "rgb(0, 118, 203)",
                    zIndex: 99998,
                    left: 0,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: 10,
                      borderBottom: "1px solid rgba(211,211,211,0.4)",
                      maxHeight: 65,
                    }}
                  >
                    <Image
                      src={"/images/Kfin-black-logo.svg"}
                      alt="logo"
                      className="logo"
                      style={{ width: "85%" }}
                    />
                    <Image
                      onClick={this.openloginResponsiveDrawer}
                      src={"/images/close.svg"}
                      alt="logo"
                      style={{ height: 15 }}
                    />
                  </div>
                  <div className="list">
                    <div className="list-item-login">
                      <a
                        href="https://mfs.kfintech.com/mfs/"
                        target="_blank"
                        onClick={this.closeloginResponsiveDrawer}
                      >
                        Home
                      </a>
                    </div>
                    <Divider />
                    <div className="list-item-login">
                      <a
                        href="https://www.kfintech.com/about-us/"
                        target="_blank"
                        onClick={this.closeloginResponsiveDrawer}
                      >
                        About
                      </a>
                    </div>
                    <Divider />
                    <div
                      className="list-item-login"
                      onClick={this.handleClickclientservices}
                    >
                      <div className="list-item">Client Services</div>
                      <div className="list-item">
                        {this.state.clientservices ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                      </div>
                    </div>
                    <Collapse
                      in={this.state.clientservices}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List component="div" disablePadding className="list-div">
                        <ListItem button>
                          <a
                            href="https://mfs.kfintech.com/mfs/distributor/distributor_Login.aspx"
                            target="_blank"
                          >
                            <ListItemText
                              primary="Distributor Services"
                              className="list-item-text"
                            />
                          </a>
                        </ListItem>
                        <ListItem button>
                          <a
                            href="https://cpupload.kfintech.com/ChannelServices/CP_Login.aspx"
                            target="_blank"
                          >
                            <ListItemText
                              className="list-item-text"
                              primary="Channel Partner Services"
                            />
                          </a>
                        </ListItem>
                        <ListItem button>
                          <a
                            href="https://mfs.kfintech.com/investor/"
                            target="_blank"
                          >
                            <ListItemText
                              className="list-item-text"
                              primary="Mutual Fund Investor Services"
                            />
                          </a>
                        </ListItem>
                        <ListItem button>
                          <a
                            href="https://mfs.kfintech.com/econnect"
                            target="_blank"
                          >
                            <ListItemText
                              primary="Korp Connect"
                              className="list-item-text"
                            />
                          </a>
                        </ListItem>
                        <ListItem button>
                          <a
                            href="https://cpupload.kfintech.com/ChannelServices/RIA_Login.aspx"
                            target="_blank"
                            onClick={this.closeloginResponsiveDrawer}
                          >
                            <ListItemText
                              className="list-item-text"
                              primary=" RIA Services"
                            />
                          </a>
                        </ListItem>
                        <ListItem button>
                          <a
                            href="https://mfs.kfintech.com/karvyalternative/"
                            target="_blank"
                            onClick={this.closeloginResponsiveDrawer}
                          >
                            <ListItemText
                              className="list-item-text"
                              primary="Alternative Investment Fund Investor"
                            />
                          </a>
                        </ListItem>
                        <ListItem button>
                          <a
                            href="https://fundswatch.kfintech.com/amcservices/"
                            target="_blank"
                            onClick={this.closeloginResponsiveDrawer}
                          >
                            <ListItemText
                              primary="AMC Services"
                              className="list-item-text"
                            />
                          </a>
                        </ListItem>
                        <ListItem button>
                          <a
                            href="https://mfs.kfintech.com/FinancialServices"
                            target="_blank"
                            onClick={this.closeloginResponsiveDrawer}
                          >
                            <ListItemText
                              className="list-item-text"
                              primary="Financial Services"
                            />
                          </a>
                        </ListItem>
                      </List>
                    </Collapse>
                    <Divider />
                    <div className="list-item-login">
                      <a
                        href="https://www.kfintech.com/contact-us/"
                        target="_blank"
                        onClick={this.closeloginResponsiveDrawer}
                      >
                        Contact us
                      </a>
                    </div>
                    <Divider />
                    <div className="list-item-login">
                      <a
                        style={{ color: "#007bff" }}
                        target="_blank"
                        onClick={this.openModal}
                      >
                        Non Login Services
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <a href="https://kfintech.com/" target="_blank">
              <Image
                src={`/images/kfin_logo.svg`}
                alt="logo_image"
                className="logo"
              />
            </a>
            <div className="home-bar">
              <a href="https://mfs.kfintech.com/mfs/" target="_blank">
                Home
              </a>

              <a href="https://www.kfintech.com/about-us/" target="_blank">
                About
              </a>

              <div className="client-services">
                <a
                  style={{
                    textDecoration: "none",
                    fontSize: 14,
                    fontFamily: "OpenSans-Regular",
                    padding: "0px 10px",
                    marginBottom: 3,
                    color: "#0076cb",
                  }}
                >
                  Client Services
                </a>
                <div className="dropdown-client-services">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginRight: 25,
                    }}
                  >
                    <div
                      className="arrow-up"
                      style={{
                        borderLeft: "10px solid transparent",
                        borderRight: "10px solid transparent",
                        borderBottom: "10px solid #047cc7",
                        width: 0,
                        height: 0,
                      }}
                    />
                  </div>
                  <div className="client-services-a">
                    <a
                      href="https://mfs.kfintech.com/mfs/distributor/distributor_Login.aspx"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      Distributor Services
                    </a>
                    <a
                      href="https://cpupload.kfintech.com/ChannelServices/CP_Login.aspx"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      Channel Partner Services
                    </a>
                    <a
                      href="https://mfs.kfintech.com/investor/"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      Mutual Fund Investor Services
                    </a>
                    <a
                      href="https://mfs.kfintech.com/econnect"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      Korp Connect
                    </a>
                    <a
                      href="https://cpupload.kfintech.com/ChannelServices/RIA_Login.aspx"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      RIA Services
                    </a>
                    <a
                      href="https://mfs.kfintech.com/karvyalternative/"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      Alternative Investment Fund Investor
                    </a>
                    <a
                      href="https://fundswatch.kfintech.com/amcservices/"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      AMC Services
                    </a>

                    <a
                      href="https://mfs.kfintech.com/FinancialServices"
                      target="_blank"
                      style={{ padding: 10 }}
                    >
                      Financial Services
                    </a>
                  </div>
                </div>
              </div>

              <a href="https://www.kfintech.com/contact-us/" target="_blank">
                Contact us
              </a>
              <button onClick={this.openModal}>Non Login Services</button>
            </div>
          </Toolbar>
          <NonLoginServicesDialog
            open={this.state.open}
            closeModal={() => this.closeModal()}
          />
        </AppBar>
      </div>
    );
  }
}
